/* eslint-disable vue/no-unused-components */
<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <service-status></service-status>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard,  ServiceStatus } from "@/components";
import NgWord from '../components/NGWord.vue';
// import ServiceStatus from "../components/ServiceStatus.vue";
// import NGWord from "../components/NGWord.vue";
export default {
  components: {
    ServiceStatus
  }
};
</script>
